(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brand-values"] && !Shopify.designMode) return;
  try {
    
function initializeHomeValues(root) {
  if (root.dataset.ready) return;
  root.dataset.ready = 'true';
  const cards = [...root.querySelectorAll('[data-home-value]')], buttons = [...root.querySelectorAll('[data-home-value-dot]')];
  function select(index) { cards.forEach((card, i) => card.classList.toggle('is-active', i === index)); buttons.forEach((button, i) => button.setAttribute('aria-pressed', String(i === index))); }
  buttons.forEach((button, i) => button.addEventListener('click', () => select(i)));
  select(0);
}
document.querySelectorAll('[data-home-values]').forEach(initializeHomeValues);
document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-home-values]').forEach(initializeHomeValues));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-celimax"] && !Shopify.designMode) return;
  try {
    
function initializeHomeHero(root) {
  if (root.dataset.ready) return;
  root.dataset.ready = 'true';
  const slides = [...root.querySelectorAll('[data-home-slide]')];
  const dots = [...root.querySelectorAll('[data-home-slide-dot]')];
  let index = 0, timer, paused = matchMedia('(prefers-reduced-motion: reduce)').matches;
  function show(next) {
    index = (next + slides.length) % slides.length;
    slides.forEach((slide, i) => { slide.hidden = i !== index; slide.inert = i !== index; slide.classList.toggle('is-active', i === index); });
    dots.forEach((dot, i) => { dot.setAttribute('aria-pressed', String(i === index)); dot.classList.toggle('is-active', i === index); });
  }
  function stop() { clearInterval(timer); }
  function start() { stop(); if (root.dataset.autoplay === 'true' && !paused && slides.length > 1) timer = setInterval(() => show(index + 1), 6000); }
  dots.forEach((dot, i) => dot.addEventListener('click', () => { show(i); start(); }));
  const pause = root.querySelector('[data-home-pause]');
  if (pause) { pause.setAttribute('aria-pressed', String(paused)); pause.addEventListener('click', () => { paused = !paused; pause.setAttribute('aria-pressed', String(paused)); start(); }); }
  root.addEventListener('mouseenter', stop);
  root.addEventListener('mouseleave', start);
  root.addEventListener('focusin', stop);
  root.addEventListener('focusout', event => { if (!root.contains(event.relatedTarget)) start(); });
  document.addEventListener('visibilitychange', () => document.hidden ? stop() : start());
  start();
}
document.querySelectorAll('[data-home-hero]').forEach(initializeHomeHero);
document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-home-hero]').forEach(initializeHomeHero));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-highlights"] && !Shopify.designMode) return;
  try {
    
function initializeHomeTabs(root) {
  if (root.dataset.ready) return;
  root.dataset.ready = 'true';
  const tabs = [...root.querySelectorAll('[data-home-tab]')], panels = [...root.querySelectorAll('[data-home-panel]')];
  function select(index) { tabs.forEach((tab, i) => { tab.setAttribute('aria-selected', String(i === index)); tab.tabIndex = i === index ? 0 : -1; }); panels.forEach((panel, i) => panel.hidden = i !== index); }
  tabs.forEach((tab, i) => { tab.addEventListener('click', () => select(i)); tab.addEventListener('keydown', event => { let next; if (event.key === 'ArrowRight') next = (i + 1) % tabs.length; if (event.key === 'ArrowLeft') next = (i + tabs.length - 1) % tabs.length; if (event.key === 'Home') next = 0; if (event.key === 'End') next = tabs.length - 1; if (next !== undefined) { event.preventDefault(); select(next); tabs[next].focus(); } }); });
  panels.forEach(panel => { const rail = panel.querySelector('[data-home-rail]'); panel.querySelector('[data-home-previous]')?.addEventListener('click', () => rail.scrollBy({left:-rail.clientWidth*.7,behavior:'smooth'})); panel.querySelector('[data-home-next]')?.addEventListener('click', () => rail.scrollBy({left:rail.clientWidth*.7,behavior:'smooth'})); });
}
document.querySelectorAll('[data-home-tabs]').forEach(initializeHomeTabs);
document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-home-tabs]').forEach(initializeHomeTabs));

  } catch(e) { console.error(e); }
})();
})();
